// src/api/v3/wilayah-api-v3.js
const API_BASE = (process.env.REACT_APP_API_BASE || '').replace(/\/$/, '')

async function handleRes(res) {
  if (!res.ok) {
    let msg = `HTTP ${res.status}`
    try {
      const json = await res.json()
      msg = json?.errors?.join(', ') || json?.error || msg
    } catch (_) {}
    throw new Error(msg)
  }
  return res.json()
}

export async function fetchProvinces() {
  const res = await fetch(`${API_BASE}/api/v3/wilayah/provinces`, {
    credentials: 'include',
    headers: { Accept: 'application/json' },
  })
  const json = await handleRes(res)
  return json?.items || []
}

export async function fetchCities(provinceId) {
  if (!provinceId) return []
  const url = new URL(`${API_BASE}/api/v3/wilayah/regencies`, window.location.origin)
  url.searchParams.set('province_code', provinceId)

  const res = await fetch(url.toString(), {
    credentials: 'include',
    headers: { Accept: 'application/json' },
  })
  const json = await handleRes(res)
  return json?.items || []
}

export async function fetchDistricts(cityId) {
  if (!cityId) return []
  const url = new URL(`${API_BASE}/api/v3/wilayah/districts`, window.location.origin)
  url.searchParams.set('regency_code', cityId)

  const res = await fetch(url.toString(), {
    credentials: 'include',
    headers: { Accept: 'application/json' },
  })
  const json = await handleRes(res)
  return json?.items || []
}

export async function fetchVillages(districtId) {
  if (!districtId) return []
  const url = new URL(`${API_BASE}/api/v3/wilayah/villages`, window.location.origin)
  url.searchParams.set('district_code', districtId)

  const res = await fetch(url.toString(), {
    credentials: 'include',
    headers: { Accept: 'application/json' },
  })
  const json = await handleRes(res)
  return json?.items || []
}

export async function fetchPostalCodesByVillage(villageId) {
  if (!villageId) return []
  const url = new URL(`${API_BASE}/api/v3/wilayah/postal_codes`, window.location.origin)
  url.searchParams.set('village_code', villageId)

  const res = await fetch(url.toString(), {
    credentials: 'include',
    headers: { Accept: 'application/json' },
  })
  const json = await handleRes(res)
  return json?.items || []
}
